export const debugValues = {
  isDebugMode: false,
  useLocalTestData: false,
  // We get a ton of warnings from the DS components that we can't resolve until dep updates. Choking console warnings gives a huge performance uplift during development serves.
  chokeConsoleWarnings: true,
};
